import React from 'react';
import { Layout } from '../../components/Layout/Layout';
import { useNavigate } from 'react-router-dom';
import { XCircle } from 'lucide-react';

export const CheckoutFailure: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Layout>
      <div className="max-w-2xl mx-auto px-4 py-16 sm:px-6 sm:py-24 lg:px-8">
        <div className="text-center">
          <XCircle className="mx-auto h-12 w-12 text-red-500" />
          <h1 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 dark:text-gray-100">
            Payment Failed
          </h1>
          <p className="mt-4 text-base text-gray-500 dark:text-gray-400">
            Your payment was declined. Please try again with a different payment method.
          </p>
          <div className="mt-6 space-y-4">
            <button
              onClick={() => navigate('/billing')}
              className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Try Again
            </button>
          </div>
        </div>
      </div>
    </Layout>
  );
}; 